import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import config from '../configs/movies-config';

import MoviesSummary from './MoviesSummary';

import * as filtersActions from '../../actions/filters-actions';
import * as queryActions from '../../actions/query-actions';

import { getInlineQueryResults } from '../../reducers/query-reducer';

import './MoviesSummary.css';

const mapStateToProps = state => ({
  queries: getInlineQueryResults(config.MOVIE_SUMMARY_FILTERS.queries, state),
  filters: state.filters
});

const mapDispatchToProps = dispatch => ({
  queryActions: bindActionCreators(queryActions, dispatch),
  filtersActions: bindActionCreators(filtersActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(MoviesSummary);
